import React, { Component } from 'react'
import {
	Breadcrumb,
	BreadcrumbItem,
	Card,
	CardBody,
	CardFooter,
	Col,
	Container,
	ListGroup,
	ListGroupItem,
	ListGroupItemHeading,
	ListGroupItemText,
	Row
} from 'reactstrap';

class AdminAccountRoute extends Component {
	render() {
		return (
			<div>
				<Breadcrumb tag="ol">
					<BreadcrumbItem tag="li">
						<a>Ecofresh Admin CP</a>
					</BreadcrumbItem>
					<BreadcrumbItem active tag="li">Account</BreadcrumbItem>
				</Breadcrumb>
				<Card className="mb-3">
					<div className="card-header">
						<i className="fa fa-user-o"></i>{' '}
						Account Information
					</div>
					<CardBody>
						<Container style={{maxWidth: "750px"}}>
							<Row style={{display: "flex", alignItems: "center"}}>
								<Col xs="3">
									<img src={(this.props.user.photos && this.props.user.photos[0]) ? this.props.user.photos[0].value : ('#')} className="img-fluid" alt="" />
								</Col>
								<Col xs="9">
									<ListGroup>
										<ListGroupItem>
											<ListGroupItemHeading>Provider</ListGroupItemHeading>
											<ListGroupItemText>{this.props.user.provider}</ListGroupItemText>
										</ListGroupItem>
										<ListGroupItem>
											<ListGroupItemHeading>First Name</ListGroupItemHeading>
											<ListGroupItemText>{this.props.user.givenName}</ListGroupItemText>
										</ListGroupItem>
										<ListGroupItem>
											<ListGroupItemHeading>Last Name</ListGroupItemHeading>
											<ListGroupItemText>{this.props.user.familyName}</ListGroupItemText>
										</ListGroupItem>
										<ListGroupItem>
											<ListGroupItemHeading>Email</ListGroupItemHeading>
											<ListGroupItemText>{this.props.user.email}</ListGroupItemText>
										</ListGroupItem>
										<ListGroupItem>
											<ListGroupItemHeading>Last Login</ListGroupItemHeading>
											<ListGroupItemText>{this.props.user.lastLogin}</ListGroupItemText>
										</ListGroupItem>
									</ListGroup>
								</Col>
							</Row>
						</Container>
					</CardBody>
					<CardFooter className="small text-muted" />
				</Card>
			</div>
		);
	}
}

export default AdminAccountRoute


// WEBPACK FOOTER //
// ./src/admin-components/routes/AdminAccountRoute.js